function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import styled from 'styled-components';
import * as IconSet from "../../../../icons/index.js";
import Button from "../../../basic/Button/Button.js";
import { getFieldSize, getLineHeight } from "../helpers.js";
import { StyledHeader, StyledHeading } from "./shared.js";
var StyledBackButtonWrapper = styled.div.withConfig({
  componentId: "CL__sc-1lfs0wo-0"
})(["align-items:center;display:flex;height:", ";"], _ref => {
  var {
    size
  } = _ref;
  return getLineHeight(size);
});
var BackButton = props => {
  return /*#__PURE__*/React.createElement(Button, _extends({
    "aria-label": "Back",
    icon: IconSet.ArrowLeft,
    tabIndex: 0,
    variant: "text"
  }, props));
};
var DeleteButton = props => {
  return /*#__PURE__*/React.createElement(Button, _extends({
    "aria-label": "Delete Item",
    icon: IconSet.Trash,
    tabIndex: 0,
    variant: "delete"
  }, props), "Delete");
};
var EditItemState = _ref2 => {
  var _items$editIndex;
  var {
    addItemTitle,
    editIndex,
    EditItemForm,
    editItemTitle,
    items,
    minItems = 0,
    onComplete,
    onItemsChange,
    size,
    subject
  } = _ref2;
  var canDelete = items.length > minItems;
  var editItem = (_items$editIndex = items[editIndex]) !== null && _items$editIndex !== void 0 ? _items$editIndex : null;
  var handleBack = onComplete;
  var handleDelete = () => {
    var newItems = [...items];
    newItems.splice(editIndex, 1);
    onItemsChange(newItems);
    onComplete();
  };
  var handleCancel = onComplete;
  var handleConfirm = item => {
    var newItems = [...items];
    newItems[editIndex] = item;
    onItemsChange(newItems);
    onComplete();
  };
  if (!EditItemForm) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledHeader, null, /*#__PURE__*/React.createElement(StyledBackButtonWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement(BackButton, {
    onClick: handleBack,
    size: getFieldSize(size)
  })), /*#__PURE__*/React.createElement(StyledHeading, null, editItem ? editItemTitle || "Edit ".concat(subject) : addItemTitle || "Add ".concat(subject)), editItem && canDelete && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: handleDelete,
    size: getFieldSize(size)
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(EditItemForm, {
    index: editIndex,
    item: editItem,
    onCancel: handleCancel,
    onConfirm: handleConfirm,
    size: size
  })));
};
export default EditItemState;